module.exports = __webpack_public_path__ + "img/stage2.51aa09d4.svg";